export default "__VITE_ASSET__D694Ts_A__"